import i18n from '../../locales/index'
import restful from '../vuex'

const state = {
  ...restful.states('depot')
}

const getters = {
  ...restful.getters('depot')
}

const actions = {
  ...restful.actions('depots')
}

const mutations = {
  ...restful.mutations('depot')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
